import analytics, { EVENTS } from 'shared-assets/lib/analytics';

const AMPLITUDE_HELP_EVENT = 'MindTouch: Help Article Requested';

export const HELP_SOURCES = {
  mindtouch: 'MindTouch Link',
  support: 'Support Link',
};

const PLATFORM_ORIGIN_LOCATION = 'https://app.kareo.com';
const MIND_TOUCH_SCRIPT =
  'https://helpme.kareo.com/@embed/dc299cbe6a8a1b2c6680f212202b56816ad9f54a97d29d84ce3e0496f34914ee.js';
const MIND_TOUCH_ID =
  'mindtouch-embed-dc299cbe6a8a1b2c6680f212202b56816ad9f54a97d29d84ce3e0496f34914ee';
const MIND_TOUCH_BACKUP_ARTICLE = 'https://helpme.kareo.com/';
const PLATFORM_DOMAIN = 'kareo.com';
const CROSS_ORIGIN_DOMAIN_DOCUMENT =
  'https://kareodev.atlassian.net/wiki/spaces/EPD/pages/2679144594/WebApp+contextual+help+cross-origin+error';

function cleanRegExp(regexStr) {
  // remove https://app.kareo.com
  regexStr = regexStr.replace(PLATFORM_ORIGIN_LOCATION, '');
  // escape
  regexStr = escapeRegExp(regexStr);
  // clean * from escape
  regexStr = regexStr.replace(/\\\*/g, '.*');

  // exclude / from regex if it finishes with .* (this will prevent mapping children urls)
  if (regexStr.substr(regexStr.length - 2) === '.*') {
    // The ?! represents a negative lookahead, ((?!\/).)* allows every character but slash (/)
    regexStr = regexStr.substr(0, regexStr.length - 2) + '((?!/).)*';
  }
  // exclude / from regex if it finishes with .*/ (this will prevent mapping children urls)
  if (regexStr.substr(regexStr.length - 3) === '.*/') {
    // The ?! represents a negative lookahead, ((?!\/).)*\/ allows every character and just one slash (/) at the end
    regexStr = regexStr.substr(0, regexStr.length - 3) + '((?!/).)*/';
  }

  // add exact match
  regexStr = '^' + regexStr + '$';
  return regexStr;
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function isDomainAllowed(hostName) {
  return (
    hostName.substring(hostName.length - PLATFORM_DOMAIN.length) ===
    PLATFORM_DOMAIN
  );
}

const ContextualHelpUtil = {
  getContextualHelpSpecificArticle: (windowLocation, contextualHelpConfig) => {
    if (isDomainAllowed(windowLocation.hostname)) {
      // this will remove the host part that it's not important to analyze
      let url = windowLocation.href.replace(windowLocation.origin, '');
      if (!!contextualHelpConfig) {
        // remove queryString
        url = url.split('?')[0];
        for (let contextualHelpMapping of contextualHelpConfig.contextualHelpMappings) {
          const regexStr = cleanRegExp(contextualHelpMapping.webAppURL);
          // test regex
          const regex = new RegExp(regexStr);
          if (regex.test(url)) {
            return contextualHelpMapping.supportURL;
          }
        }
        return contextualHelpConfig.defaultSupportURL;
      } else {
        // This will be the default in case of any issues getting the mappings
        return MIND_TOUCH_BACKUP_ARTICLE;
      }
    } else {
      return CROSS_ORIGIN_DOMAIN_DOCUMENT;
    }
  },
  getMindTouchScripts: hostName => {
    if (isDomainAllowed(hostName)) {
      let node1 = document.createElement('script');
      node1.src = MIND_TOUCH_SCRIPT;
      node1.async = 'async';
      let node2 = document.createElement('script');
      node2.type = 'mindtouch/embed';
      node2.id = MIND_TOUCH_ID;
      let mindTouchScripts = {};
      mindTouchScripts.node1 = node1;
      mindTouchScripts.node2 = node2;
      return mindTouchScripts;
    }
  },
  // TODO validate amplitud
  trackHelpClick: ({ path, article, source }, hostName) => {
    // Not sending stats to Amplitud if the Contextual Help activity is happening in a different domain since the article would be the documentation of the cross-origin error
    if (HELP_SOURCES.mindtouch !== source || isDomainAllowed(hostName)) {
      analytics.track(EVENTS.LINK_CLICKED, {
        name: AMPLITUDE_HELP_EVENT,
        article,
        path,
        source,
      });
    }
  },
};

export default ContextualHelpUtil;
